import styled from 'styled-components';
import { statCard } from 'shared/styles/theme';


const pointOnArc = (cx, cy, r, deg) => {
  const rad = (deg * Math.PI) / 180;
  return { x: cx + r * Math.cos(rad), y: cy - r * Math.sin(rad) };
};

const Gauge = ({
  ratio = 0,
  icon,
  alt = '',
  size = 64,
  stroke = 6,
  fillColor = statCard.gaugeFill,
}) => {
  const width = size;
  const r = (width - stroke) / 2;
  const cx = width / 2;
  const cy = r + stroke / 2;
  const height = cy + stroke / 2;
  const clamped = Math.max(0, Math.min(1, ratio));

  const track = `M ${stroke / 2} ${cy} A ${r} ${r} 0 0 1 ${width - stroke / 2} ${cy}`;
  const end = pointOnArc(cx, cy, r, 180 - clamped * 180);
  const fill = `M ${stroke / 2} ${cy} A ${r} ${r} 0 0 1 ${end.x} ${end.y}`;

  const iconSize = Math.round(r * 0.62);

  return (
    <Wrapper style={{ width, height }}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <path
          d={track}
          fill='none'
          stroke={statCard.gaugeTrack}
          strokeWidth={stroke}
          strokeLinecap='round'
        />
        {clamped > 0 && (
          <path
            d={fill}
            fill='none'
            stroke={fillColor}
            strokeWidth={stroke}
            strokeLinecap='round'
          />
        )}
      </svg>
      {icon && (
        <Icon src={icon} alt={alt} style={{ width: iconSize, height: iconSize }} />
      )}
    </Wrapper>
  );
};

export default Gauge;

const Wrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`;
const Icon = styled.img`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  object-fit: contain;
`;
